import styled from 'styled-components'
import GridListCell from './GridListCell'
import LineActions from '../listView/LineActions'
import { resolveColumn } from './resolveColumn'
import LineDocumentsButton from '../documents/LineDocumentsButton'
import { trailingCellsOf, TrailingCell } from './trailingCells'

const RowItem = styled.div`
    display: flex;
    flex: 1 0 auto;
    min-width: 0px;
    opacity: 1;
    min-height: 36px;
    position: relative;
    border-top: 1px solid ${({ theme }) => theme.table.border};
    align-items: stretch;
    color: ${({ theme }) => theme.font.color};
    padding: 0px;
    padding-left: ${({ $reorderable }) => $reorderable ? '1.5rem' : '0'};
    text-decoration: none;
    background-color: transparent;
`

const StatusDot = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $status, theme }) => theme.emotive[$status].color};
`


const GridListRow = ({
    row,
    rowIdx,
    columns,
    config,
    onAction,
    onUpdateCell,
    useStore,
    entity,
    cursor,
    onNavigate,
    onCellClick,
    onCellEditingChange,
    isDirty,
    isSaved,
    reorderable,
}) => {
    const handleAction = (menuItem, item) => {
        if (onAction) onAction(menuItem, item, rowIdx)
    }

    // The line's documents (a paper clip with their count), its saved status
    // and its actions — the same cells the header lays out (trailingCellsOf).
    const trailing = {
        documents: () => <LineDocumentsButton lineDocuments={config.lineDocuments} index={rowIdx} />,
        status: () => <>
            {isDirty && !isSaved && <StatusDot $status="warning" />}
            {isSaved && <StatusDot $status="success" />}
        </>,
        actions: () => <LineActions
            lineActions={config.resolvedLineActions || config.lineActions}
            item={row}
            onAction={handleAction}
        />
    }

    return (
        <RowItem $reorderable={reorderable}>
            {columns.map((baseCol, colIdx) => {
                const col = resolveColumn(baseCol, row)
                return <GridListCell
                    key={col.id}
                    column={col}
                    row={row}
                    rowIdx={rowIdx}
                    colIdx={colIdx}
                    editable={col.editable}
                    onUpdate={onUpdateCell}
                    useStore={useStore}
                    entity={entity}
                    isFocused={cursor?.rowIdx === rowIdx && cursor?.colIdx === colIdx}
                    browsing={!!cursor?.browse}
                    onNavigate={onNavigate}
                    onCellClick={onCellClick}
                    onCellEditingChange={onCellEditingChange}
                />
            })}
            {trailingCellsOf(config).map((cell, i) => (
                <TrailingCell key={cell.id} $len={cell.width} $first={i === 0}>
                    {trailing[cell.id]()}
                </TrailingCell>
            ))}
        </RowItem>
    )
}

export default GridListRow
